export default __webpack_public_path__ + "static/Group-148805-0ef5fc16efebe93b0b8a12623112cf4f.png";